import AMobileDataForm from "./aMobileDataForm";
import SystemLogAccess from "../../../services/database/systemLogAccess";
import {systemLogTable} from "../../../config.json";
// import Joi from "joi-browser";
import Joi from "@hapi/joi";

class MobileSystemLogDataForm extends AMobileDataForm {
    record = {};

    tableName = "system configuration";
    tableDefinition = {
        0: {
            // id: 0,
            name: "id",
            value: "",
            label: "Id",
            disabled: true
        },
        1: {
            // id: 1,
            name: "name",
            value: "",
            label: "Name",
            disabled: true
        },
        2: {
            // id: 2,
            name: "value",
            value: "",
            label: "Wert",
            autofocus: true
        }
    };

    schema = {value: Joi.string().required()};

    loadData = async () => {
        const {tableDefinition} = this;
        const {database, id} = this.props;
        let dataTableList = [];
        const data = {};

        if (database) {
            this.record = await SystemLogAccess.getById(database, systemLogTable, id);
            if (this.record) {
                let item = {...tableDefinition[0]};
                // item["value"] = this.record.id;
                data["id"] = this.record.id;
                dataTableList.push(item);

                item = {...tableDefinition[1]};
                // item["value"] = this.record.name;
                data["name"] = this.record.name;
                dataTableList.push(item);

                item = {...tableDefinition[2]};
                // item["value"] = this.record.value;
                data["value"] = this.record.value;
                dataTableList.push(item);
            }
        }
        this.setState({dataTableList, data});
    };
}

export default MobileSystemLogDataForm;
